"use client";

import { useEffect, useState } from "react";

/**
 * True after window load + two animation frames, so stylesheets and fonts
 * have applied before any layout-measuring effects run.
 */
export function useDocumentReady() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const markReady = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setReady(true));
      });
    };

    if (document.readyState === "complete") {
      markReady();
      return;
    }

    window.addEventListener("load", markReady, { once: true });
    return () => window.removeEventListener("load", markReady);
  }, []);

  return ready;
}
